import { Icon } from '@iconify/react/dist/iconify.js'
import React, { useEffect, useState } from 'react'
import { Link, Navigate } from 'react-router-dom'
import { apiCall } from '../utils/apiService'

const SignUpLayer = () => {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault(); // Prevent default form submission
        setIsLoading(true);
        setError("");
        try {
            const data = await apiCall({
                url: `user/signup`,
                method: 'Post',
                body: { email, password, name },
            });
            if (data.success) {
                window.location.href = '/login';
            } else {
                setError(error.message);
            }
        } catch (error) {
            setError(error.message);
            console.error('Login error:', error); // Log error to console
        }
    };

    useEffect(() => {
        document.title = "Sign Up";
    }, []);

    const imageBackground = {
        backgroundImage: `url('assets/images/whatsapp.png')`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        height: '100vh',
        width: '100%'
    };

    return (
        <div className="vh-100" style={imageBackground}>
            <div className="container vh-100 d-flex align-items-center justify-content-center">
                <div className="col-md-6 col-lg-5">
                    <div className="card shadow px-md-5 pb-md-3 px-3" style={{
                        background: '#bedfbe',
                        borderRadius: '20px'
                    }}>
                        {/* Logo */}
                        <div className="text-center mb-4">
                            <Link to="/" className="d-flex align-items-center justify-content-center text-decoration-none">
                                <img src="/assets/images/alphaxcloud.png" width={300} alt="" />
                            </Link>
                        </div>

                        {/* Header */}
                        <div className="text-center mb-4">
                            <h6 className="fw-bold">Sign Up to your Account</h6>
                            <p className="text-muted small">Welcome back! please enter your detail</p>
                        </div>

                        {/* Form */}
                        <form onSubmit={handleSubmit}>
                            <div className="mb-3 position-relative">
                                <div className="icon-field mb-16">
                                    <span className="icon top-50 translate-middle-y">
                                        <Icon icon="f7:person" />
                                    </span>
                                    <input
                                        type="text"
                                        className="form-control h-56-px bg-neutral-50 radius-12"
                                        placeholder="Name"
                                        value={name}
                                        onChange={(e) => setName(e.target.value)}
                                    />
                                </div>
                            </div>
                            <div className="mb-3 position-relative">
                                <div className="icon-field mb-16">
                                    <span className="icon top-50 translate-middle-y">
                                        <Icon icon="mage:email" />
                                    </span>
                                    <input
                                        type="email"
                                        className="form-control h-56-px bg-neutral-50 radius-12"
                                        placeholder="Email"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                    />
                                </div>
                            </div>
                            <div className="position-relative mb-3">
                                <div className="icon-field">
                                    <span className="icon top-50 translate-middle-y">
                                        <Icon icon="solar:lock-password-outline" />
                                    </span>
                                    <input
                                        type={showPassword ? '' : 'password'}
                                        className="form-control h-56-px bg-neutral-50 radius-12"
                                        id="your-password"
                                        placeholder="Password"
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                    />
                                </div>
                                <span
                                    onClick={() => setShowPassword(!showPassword)}
                                    disabled={isLoading}
                                    className={`toggle-password ${!showPassword ? 'ri-eye-line' : 'ri-eye-off-line'} cursor-pointer position-absolute end-0 top-50 translate-middle-y me-16 text-secondary-light`}
                                    data-toggle="#your-password"
                                />
                            </div>

                            {error && (
                                <div className="alert alert-danger py-2 text-center">{error}</div>
                            )}

                            <button
                                type="submit"
                                className="btn btn-success w-100 fw-semibold"
                                disabled={isLoading}
                            >
                                {isLoading ? (
                                    <span className="spinner-border spinner-border-sm me-2"></span>
                                ) : null}
                                {isLoading ? "Signing Up..." : "Sign Up"}
                            </button>

                            <div className="text-center mt-3">
                                Already have an account?
                                <Link to="/login" className="text-success-600 fw-semibold ms-2">
                                    Sign In
                                </Link>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SignUpLayer